import React, { useEffect, useRef, useState } from "react";
import logo from "assets/images/logo.png";
import Button from "components/primary-button/button";
import styles from "./header.module.scss";
import classNames from "classnames";
import { Link, useLocation, useNavigate } from "react-router-dom";
export default function Header() {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const location = useLocation();
  const close = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };
  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenu(false);
    document.body.classList.remove("active");
  }, [location]);

  // The fixed banner wraps to more lines on narrow screens; publish its real height so the
  // header and mobile menu sit below it instead of being covered.
  const bannerRef = useRef(null);
  useEffect(() => {
    const el = bannerRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const root = document.documentElement;
    const update = () => root.style.setProperty("--nb-banner-h", `${el.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty("--nb-banner-h");
    };
  }, []);

  return (
    <>
      <div
        ref={bannerRef}
        style={{
          background: "#26cead",
          color: "#06140f",
          textAlign: "center",
          padding: "8px 0",
          zIndex: 11,
          width: "100%",
          position: "fixed",
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <strong>NEW:</strong> Free to use · 0.0001 SOL minimum tip · TPS scales automatically with traffic quality.{" "}
        <a
          href="/auth"
          style={{
            textDecoration: "underline",
            fontWeight: "bold",
            color: "#06140f",
            marginLeft: "6px",
            whiteSpace: "nowrap",
          }}
        >
          Get your API key
        </a>
      </div>
      <div
        className={styles["header"]}
      >
        <div></div>
        <div className={"auto__container"}>
          <div className={styles["header__inner"]}>
            <Link to="" className={styles["header__inner-logo"]}>
              <img src={logo} alt="logo" />
            </Link>
            <div
              onClick={close}
              className={classNames(styles["nav"], {
                [styles.active]: menu,
              })}
            >
              <div className={styles["nav__inner"]}>
                <div className={styles["nav__inner-links"]}>
                  <a href="#feature">Features</a>
                  <a href="#contact">Contact</a>
                  <a href="https://docs.nextblock.io/" target="_blank">Documentation</a>
                </div>
                <div className={styles["nav__inner-btn"]}>
                  <Button
                    onClick={() => navigate("../../auth/sign-in")}
                    text="Sign In"
                    type={"primary"}
                  />
                </div>
              </div>
            </div>
            <div
              className={classNames(styles["burger"], {
                [styles.active]: menu,
              })}
              onClick={() => setMenu(!menu)}
            >
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
